import { SvgIconProps } from 'ui/icons/SvgIcon';

export const BusinessInitiatedTemplate = ({ height = 110, width = 60 }: SvgIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 2061 3001"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_ddd_16148_220427)">
      <rect x="460.238" y="200.9" width="1200" height="2200" rx="80" fill="#ECE5DD" />
    </g>
    <path
      d="M460.238 280.9C460.238 236.717 496.056 200.9 540.238 200.9H1580.24C1624.42 200.9 1660.24 236.717 1660.24 280.9V440.9H460.238V280.9Z"
      fill="#128C7E"
    />
    <g filter="url(#filter1_ddd_16148_220427)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M399.532 680.9C355.349 680.9 319.532 716.717 319.532 760.9V1483.71L168.325 1679.42C147.013 1707.01 170.735 1746.48 206.255 1742.55L320.035 1729.93C324.519 1769.86 358.401 1800.9 399.532 1800.9H1280.21C1324.39 1800.9 1360.21 1765.08 1360.21 1720.9V760.9C1360.21 716.717 1324.39 680.9 1280.21 680.9H399.532Z"
        fill="white"
      />
    </g>
    <path
      d="M420.234 1400.9H860.234"
      stroke="#E0DEDF"
      stroke-width="54"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M420.234 1540.9H1140.23"
      stroke="#E0DEDF"
      stroke-width="54"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M420.234 1680.9H1140.23"
      stroke="#E0DEDF"
      stroke-width="54"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M400.234 852.9C400.234 813.136 432.47 780.9 472.234 780.9H1228.23C1268 780.9 1300.23 813.136 1300.23 852.9V1208.9C1300.23 1248.66 1268 1280.9 1228.23 1280.9H472.234C432.47 1280.9 400.234 1248.66 400.234 1208.9V852.9Z"
      fill="#E6FBFF"
    />
    <path
      d="M400.234 1160.9H1300.23V1208.9C1300.23 1248.66 1268 1280.9 1228.23 1280.9H472.234C432.47 1280.9 400.234 1248.66 400.234 1208.9V1160.9Z"
      fill="#34C3F2"
    />
    <path
      d="M480.234 940.9C480.234 983.005 513.919 1020.9 560.234 1020.9C606.55 1020.9 640.234 987.216 640.234 940.9C640.234 894.584 602.34 860.9 560.234 860.9C518.129 860.9 480.234 894.584 480.234 940.9Z"
      fill="#F2CA1B"
    />
    <path
      d="M630.234 1080.89L560.234 1160.89L1160.23 1160.88L1000.23 1000.91C950.234 950.9 920.234 900.893 870.234 1000.92C814.704 1112 790.234 1100.91 790.234 1100.91C783.568 1100.91 760.234 1094.89 720.234 1070.89C680.234 1046.89 643.568 1067.56 630.234 1080.89Z"
      fill="#59C1A7"
    />
    <defs>
      <filter
        id="filter0_ddd_16148_220427"
        x="60.2383"
        y="0.899902"
        width="2000"
        height="3000"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="10" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_16148_220427" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="40" />
        <feGaussianBlur stdDeviation="60" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_16148_220427"
          result="effect2_dropShadow_16148_220427"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="200" />
        <feGaussianBlur stdDeviation="200" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
        <feBlend
          mode="normal"
          in2="effect2_dropShadow_16148_220427"
          result="effect3_dropShadow_16148_220427"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect3_dropShadow_16148_220427"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_ddd_16148_220427"
        x="0.25"
        y="600.9"
        width="1519.96"
        height="1440"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="10" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_16148_220427" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="20" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0" />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_16148_220427"
          result="effect2_dropShadow_16148_220427"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="80" />
        <feGaussianBlur stdDeviation="80" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0" />
        <feBlend
          mode="normal"
          in2="effect2_dropShadow_16148_220427"
          result="effect3_dropShadow_16148_220427"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect3_dropShadow_16148_220427"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);
